import { useState, useLayoutEffect, RefObject } from 'react'

const useIsOverflow = (
  ref: RefObject<HTMLElement>,
  callback?: (isOverflow: boolean) => void,
): boolean | undefined => {
  const [isOverflow, setIsOverflow] = useState<boolean | undefined>(undefined)

  useLayoutEffect(() => {
    const { current } = ref

    const trigger = () => {
      if (!current) return

      const hasOverflow =
        current.scrollHeight > current.clientHeight ||
        current.scrollWidth > current.clientWidth

      setIsOverflow(hasOverflow)
      if (callback) {
        callback(hasOverflow)
      }
    }

    if (current) {
      trigger()
    }
  }, [callback, ref])

  return isOverflow
}

export default useIsOverflow
